<template lang="pug">
div
  el-row
    el-col(:sm="20")
      h2
        span Паричен поток
        el-dropdown(split-button, type="success", trigger="click", @click="$router.push(url + '/new?type=1&document=1')")
          i.el-icon-plus.el-icon--left
          span Приходна фактура
          el-dropdown-menu(slot="dropdown")
            el-dropdown-item(@click.native="$router.push(url + '/new?type=1&document=2')") Приход без фактура
        el-dropdown(split-button, type="danger", trigger="click", @click="$router.push(url + '/new?type=2&document=1')")
          i.el-icon-plus.el-icon--left
          span Разходна фактура
          el-dropdown-menu(slot="dropdown")
            el-dropdown-item(@click.native="$router.push(url + '/new?type=2&document=2')") Разход без фактура
    el-col(:sm="4")
      el-button.fr(type="primary", :disabled="!filters.dateFrom || !filters.dateTo", @click="exportData") Експорт
  el-form(:model="filters")
    el-row
      el-col(:sm="6")
        el-form-item
          el-date-picker(:value="filters.dateFrom", @input="filters.dateFrom = modelDate($event)", placeholder="От дата")
      el-col(:sm="6")
        el-form-item
          el-date-picker(:value="filters.dateTo", @input="filters.dateTo = modelDate($event)", placeholder="До дата")
      el-col(:sm="8")
        el-form-item
          el-select(v-model="filters.ContragentId", placeholder="Контрагент (Име/ЕИК/Фирма)", clearable, :remote-method="contragentAhead", filterable, remote, :loading="contragentLoading")
            el-option(v-for="c in contragentOptions", :label="c.text", :value="c.id", :key="c.id")
      el-col(:sm="4")
        el-form-item
          el-select(v-model="filters.CompanyId", clearable, placeholder="Фирма")
            el-option(v-for="c in companies", :label="c.name", :value="c.id", :key="c.id")
    el-row
      el-col(:sm="4")
        el-form-item
          el-select(v-model="filters.type", clearable, placeholder="Финанси")
            el-option(v-for="(type, id) in consts.paymentType", :label="type.title", :value="id", :key="id")
      el-col(:sm="4")
        el-form-item
          el-select(v-model="filters.document", clearable, placeholder="Документ")
            el-option(v-for="(document, id) in consts.paymentDocument", :label="document.title", :value="id", :key="id")
      el-col(:sm="4")
        el-form-item
          el-select(v-model="filters.status", clearable, placeholder="Статус")
            el-option(v-for="(status, id) in Object.assign({}, consts.paymentStatus, {'-1': {title: 'Просрочени'}})", :label="status.title", :value="id", :key="id")
      el-col(:sm="4")
        el-form-item
          el-input(v-model="filters.num", placeholder="Фактура №")
      el-col(:sm="3")
        el-form-item
          el-select(v-model="filters.method", clearable, placeholder="Разплащане")
            el-option(v-for="(method, id) in consts.paymentMethod", :label="method.title", :value="id", :key="id")
      el-col(:sm="3")
        el-form-item
          el-select(v-model="filters.subject", clearable, placeholder="Основание")
            el-option-group(label="Приход", :disabled="filters.type != 1")
              el-option(v-for="(subject, id) in consts.subjectType[1]", :label="subject.title", :value="id", :key="id")
            el-option-group(label="Разход", :disabled="filters.type != 2")
              el-option(v-for="(subject, id) in consts.subjectType[2]", :label="subject.title", :value="id", :key="id")

      el-col(:sm="2")
        el-form-item
          el-button(@click="clearFilters") Изчисти

  datatable(ref="datatable", :url="apiUrl", :filters="filters", :row-class-name="tableRowClassName", default-order-by="id", default-order-dir="descending")
    el-table-column(prop="document", label="Документ", width="140", class-name="document-column")
      template(slot-scope="scope")
        router-link(:to="url + '/' + scope.row.id")
          el-tag(:type="tagType(scope.row)", :disable-transitions="true") {{ consts.paymentDocument[scope.row.document].title.replace(' известие', '') }}
        el-tooltip(v-if="scope.row.status != 2 && scope.row.overdue > 0", :content="'Просрочено с ' + scope.row.overdue + ' дни'", placement="top", effect="light")
          el-icon.icon-overdue(name="warning")
    el-table-column(prop="publishedAt", label="От дата", :formatter="dateFormatter", width="100")
    el-table-column(prop="num", label="Фактура №", :formatter="invoiceNumFormatter", width="100")
    el-table-column(prop="Contragent", label="Контрагент", :formatter="contragentFormatter", width="140", :show-overflow-tooltip="true")
    el-table-column(type="expand")
      template(slot-scope="scope")
        p(v-for="s in scope.row.Subjects", :class="scope.row.type == 1 ? 'text-success' : 'text-danger' ")
          | {{ common.invoiceSubjectText(s, scope.row) }}
          span [{{ s.quantity }} x {{ common.formatPrice(s.price) }} {{ s.discount ? '(-' + s.discount + '%)' : ''}} = {{ common.formatPrice(s.quantity * s.priceDiscounted) }}]
    el-table-column(prop="Subjects", label="Описание/Основание", class-name="subjects-column", :formatter="subjectsFormatter")
    el-table-column(prop="priceTotal", label="Сума", :formatter="priceFormatter", width="80")
    el-table-column(prop="Company", label="Фирма", :formatter="companyFormatter", width="130")
    el-table-column(prop="method", label="Плащане", :formatter="methodFormatter", width="90")

  el-row(style="text-align:center; margin-bottom: 10px")
    el-button(v-if="!showTotal" type="info" @click="getTotal") Общо Приходи/Разходи
    div(v-if="showTotal" style="margin-bottom:18px").
      <span class="text-success">{{ income | formatPrice}}</span> - <span class="text-danger">{{ outcome | formatPrice}}</span> = {{ delta | formatPrice }}
</template>

<script>
import format from 'date-fns/format'
import Datatable from './Datatable.vue'
import listMixin from '../mixins/listMixin.js'
import paymentsMixin from '../mixins/paymentsMixin.js'

export default {
  name: 'PaymentList',
  mixins: [listMixin, paymentsMixin],
  data () {
    return {
      url: '/payments',
      apiUrl: '/payments',
      filters: {
        dateFrom: '',
        dateTo: '',
        ContragentId: '',
        CompanyId: '',
        type: '',
        document: '',
        status: '',
        num: '',
        method: '',
        subject: '',
      },
      contragentOptions: [],
      contragentLoading: false,
      showTotal: false,
      income: 0,
      outcome: 0,
      delta: 0
    }
  },
  computed: {
    companies () {
      return this.$auth.check() ? this.$auth.user().tables.companies : []
    }
  },
  methods: {
    contragentAhead (term, cb) {
      this.contragentLoading = true
      this.$http.get('/ahead/contragent', {params: {term}}).then(response => {
        this.contragentLoading = false
        this.contragentOptions = response.data.results.map(r => {
          r.text = r.name + ' (' + r.eik + ')' + (r.companyName ? ' (' + r.companyName + ')' : '')
          return r
        })
      }).catch(error => {
        console.error(error)
        this.$notify.error({title: 'Error', message: 'Error loading contragents filter. Check console.'});
      })
    },
    exportData () {
      const params = Object.keys(this.filters).map(f => f + '=' + this.filters[f])
      window.open(`${this.$baseURL}payments?${params.join('&')}&format=csv&token=${this.$auth.token()}`)
    },
    getTotal () {
      this.$http.get(this.url, {
        params: {
          ...this.filters,
          format: 'sums'
        }
      })
        .then(response => {
          this.income = response.data.income
          this.outcome = response.data.outcome
          this.delta = response.data.delta
          this.showTotal = true
        })
        .catch(error => {
          console.error(error)
          this.loading = false
          this.$notify.error({title: 'Error', message: 'Error loading records. Check console.'});
        })
    }
  },
  created () {
    this.$watch('filters', () => {
      this.showTotal = false
    }, {deep: true, immediate: true})
  },
  components: {
    Datatable
  }
}
</script>

<style lang="stylus">
.document-column .el-tooltip
  display inline-block
</style>